module.exports = __webpack_public_path__ + "img/default-bg.cfd2606e.png";